import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ReactComponent as CloseIcon } from "../../../../assets/images/x.svg";

function DeleteTrashIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5429 21.0037H8.4571C7.2809 21.0037 6.30301 20.0981 6.21279 18.9254L5.24719 6.37256H18.7528L17.7872 18.9254C17.697 20.0981 16.7191 21.0037 15.5429 21.0037V21.0037Z" stroke="#FF4D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.0033 6.37277H3.99664" stroke="#FF4D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.18632 2.99658H14.8137C15.4352 2.99658 15.9391 3.50047 15.9391 4.12205V6.37299H8.06085V4.12205C8.06085 3.82356 8.17943 3.53729 8.39049 3.32622C8.60156 3.11516 8.88783 2.99658 9.18632 2.99658Z" stroke="#FF4D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.99915 17.0022H14.0008" stroke="#FF4D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  );
}

export default function CustomerDeleteModal({
  open,
  customerName,
  bulkCount = 0,
  title,
  bulkLabel = "customers",
  onClose,
  onConfirm,
  loading = false,
}) {
  const isBulk = bulkCount > 0;
  const displayName = isBulk ? `${bulkCount} ${bulkLabel}` : customerName;
  const modalTitle = title ?? `Delete Customer${isBulk ? "s" : ""}`;
  const [pending, setPending] = useState(false);
  const busy = loading || pending;

  useEffect(() => {
    if (!open || !loading) setPending(false);
  }, [open, loading]);

  const handleClose = () => {
    if (busy) return;
    onClose?.();
  };

  const handleConfirm = () => {
    if (busy) return;
    setPending(true);
    onConfirm?.();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
        },
      }}
      PaperProps={{
        sx: {
          width: 408,
          maxWidth: "95vw",
          borderRadius: "12px",
          border: "1px solid #D5DCE1",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          m: 2,
        },
      }}
    >
      <Box sx={{ p: "24px", position: "relative" }}>
        <IconButton
          onClick={handleClose}
          disabled={busy}
          size="small"
          sx={{ position: "absolute", top: 16, right: 16, p: 0.5 }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "#FFF1F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DeleteTrashIcon />
        </Box>

        <Typography
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 18,
            fontWeight: 500,
            lineHeight: "20px",
            mt: "24px",
            mb: 1,
          }}
        >
          {modalTitle}
        </Typography>

        <Typography
          sx={{
            color: "#556575",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "22px",
            mb: 3,
          }}
        >
          Are you sure you want to delete{" "}
          <Box component="span" sx={{ color: "#061522", fontWeight: 400 }}>
            {displayName}
          </Box>
          ? This action cannot be undone.
        </Typography>

        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            onClick={handleClose}
            disabled={busy}
            sx={{
              width: 176,
              height: 40,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              color: "#405261",
              fontFamily: "Inter",
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "18px",
              textTransform: "none",
              "&:hover": { background: "#FFF", borderColor: "#C5CED6" },
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={busy}
            onClick={handleConfirm}
            sx={{
              width: 176,
              height: 40,
              borderRadius: "8px",
              background: "#FF4D4F",
              color: "#FFF",
              fontFamily: "Inter",
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "18px",
              textTransform: "none",
              "&:hover": { background: "#E63E40" },
              "&.Mui-disabled": {
                background: "#FF4D4F",
                color: "#FFF",
                opacity: 0.6,
              },
            }}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
